export default {"src":"/_next/static/media/step-2.b18cca94.svg","height":24,"width":16};